module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\"><path class=\"asda-icon__draw\" fill-rule=\"evenodd\" d=\"M15 25C9.477 25 5 20.523 5 15S9.477 5 15 5s10 4.477 10 10-4.477 10-10 10zm0-1a9 9 0 100-18 9 9 0 000 18zm-4-12h8a1 1 0 010 2h-8a1 1 0 010-2zm0 4h8a1 1 0 010 2h-8a1 1 0 010-2z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/circular/asda-ingredient.svg
// module id = 653
// module chunks = 0